@if (titleText || showValue) {
  <div class="title-text-row m-t-32">
    @if (titleText) {
      <span>{{ titleText | translate }}</span>
    }
    <!-- This fills the remaining space of the current row -->
    <span class="fill-remaining-space"></span>
    @if (showValue) {
      <span>{{ value | toLocaleNumber }} / {{ maxValue | toLocaleNumber }}</span>
    }
  </div>
}
<div class="progress" [style.height.px]="height">
  @if (progress !== 0) {
    <div class="determinate" [style.background-color]="color" [style.min-width.px]="value !== 0 ? 8 : 0" [style.width.%]="progress"></div>
  }
</div>
